import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/permissionPrompt.css';
import LockIconPointer from './LockIconPointer';
import LoadingAnimation from './Loading';

const PermissionPrompt = ({setShowPermissionModal}) => {
  const {
    setHasCameraPermission,
    hasCameraPermission,
    hasMicrophonePermission,
  } = useAuth();

  const [cameraMessage, setCameraMessage] = useState('');
  const [microphoneMessage, setMicrophoneMessage] = useState('');

  const [cameraBlocked, setCameraBlocked] = useState(false);
  const [microphoneBlocked, setMicrophoneBlocked] = useState(false);

  const showBrowserHelp = (
    <div className="alert alert-danger mt-2">
      Permission blocked. Click the <strong>🔒 lock or ℹ️ icon</strong> in the browser address bar and allow access manually.
    </div>
  );

  const requestCameraPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setHasCameraPermission(true);
      setCameraMessage('✅ Camera access granted!');
      setCameraBlocked(false);
      stream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      console.error('Camera permission error:', error);
      setHasCameraPermission(false);
      setCameraMessage('❌ Camera permission denied.');
      if (error.name === 'NotAllowedError' || error.name === 'SecurityError') {
        setCameraBlocked(true);
      }
    }
  };

  const requestMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicrophoneMessage('🎙️ Microphone access granted! ✅');
      setMicrophoneBlocked(false);
      stream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      console.error('Microphone permission error:', error);
      setMicrophoneMessage('❌ Microphone permission denied.');
      if (error.name === 'NotAllowedError' || error.name === 'SecurityError') {
        setMicrophoneBlocked(true);
      }
    }
  };

  useEffect(() => {
    if (hasCameraPermission) setCameraMessage('✅ Camera access granted!');
    if (hasMicrophonePermission) setMicrophoneMessage('🎙️ Microphone access granted! ✅');
  }, [hasCameraPermission, hasMicrophonePermission]);

  return (
    <div className="card-body text-center">
      {!hasCameraPermission && !hasMicrophonePermission && (
        <LoadingAnimation text="Checking Permissions..." />
      )}

      {cameraBlocked && showBrowserHelp}


      {(cameraBlocked || microphoneBlocked) && <LockIconPointer />}

      {/* Camera Button */}

      {!cameraMessage && 
       <div className="mb-2">
        <button type="button" className="btn btn-outline-primary w-100" onClick={requestCameraPermission} disabled={cameraBlocked} >
          🎥 Grant Camera Access
        </button>
      </div>
      }


      {cameraMessage && <div className="alert alert-info mt-2">{cameraMessage}</div>}


     

      {/* Microphone Button */}
      <div className="mb-2">
        {!microphoneMessage &&
        <button type="button" className="btn btn-outline-danger w-100" onClick={requestMicrophonePermission} disabled={microphoneBlocked} >
          🎙️ Grant Microphone Access
        </button>
        
        }
        
        {microphoneMessage && <div className="alert alert-info mt-2">{microphoneMessage}</div>}
        {microphoneBlocked && showBrowserHelp}
      </div>

      <hr />
      <p className="text-muted small">
        If permissions were previously blocked, please enable them via your browser's lock icon 🔒.
      </p>

      <button type="button" className="btn btn-outline-danger w-100" onClick={()=>setShowPermissionModal(false)}>
        Close
      </button>
    </div>
  );
};

export default PermissionPrompt;
